export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8222.a22ad977.jpg";